/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from "react";
import Collapse from "react-bootstrap/Collapse";
import { toast } from "react-hot-toast";
import Select from "react-select";
import Card from "../../../../../components/Cards/Card";
import { ManagerService } from "../../../../../utils/services/manager.service";

function ConfigureEmailServer({ dictionary }) {
  const menuPortalTarget = document.getElementById("root");
  const [open] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [color, setColor] = useState(false);
  const [serviceProvider, setServiceProvider] = useState({});
  const [userName, setUserName] = useState("");
  const [emailServer, setEmailServer] = useState("");
  const [outgoingEmail, setOutgoingEmail] = useState("");
  const [outgoingPort, setOutgoingPort] = useState(0);
  const [testEmail, setTestEmail] = useState("");

  const disabled =
    serviceProvider?.value !== "" &&
    userName !== "" &&
    emailServer !== "" &&
    outgoingEmail !== "" &&
    outgoingPort >= 0 &&
    testEmail !== ""
      ? false
      : true;

  const setUpEmailServer = async (payload) => {
    setLoading(true);
    try {
      const response = await ManagerService.setUpEmailServer(payload);
      if (response.status === 200) {
        toast.success("email server successfully set up");
        setServiceProvider({});
        setUserName("");
        setUpEmailServer("");
        setOutgoingEmail("");
        setOutgoingPort(0);
        setTestEmail("");
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      return error;
    }
    setLoading(false);
  };

  const setUpTestEmailServer = async (payload) => {
    setIsLoading(true);
    try {
      const response = await ManagerService.setUpTestEmailServer(payload);
      if (response.status === 200) {
        toast.success("email test server successfully set up");
        setServiceProvider({});
        setUserName("");
        setUpEmailServer("");
        setOutgoingEmail("");
        setOutgoingPort(0);
        setTestEmail("");
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      return error;
    }
    setIsLoading(false);
  };

  const payload = {
    email: userName,
    password: emailServer,
    apiToken: "",
    smtpHostName: outgoingEmail,
    portNumber: outgoingPort,
    serviceProvider: serviceProvider?.value || "SMTP",
  };

  const testPayload = {
    email: userName,
    password: emailServer,
    apiToken: "",
    smtpHostName: outgoingEmail,
    portNumber: outgoingPort,
    serviceProvider: serviceProvider?.value || "SMTP",
    emailSendTo: testEmail,
  };

  return (
    <>
      <Card>
        <ul className="list-group">
          <li
            className="list-group-item collapse-text text-uppercase fw-bold"
            onClick={() => setColor(!color)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
            style={{ cursor: "pointer", borderBottom: "0px solid" }}
          >
            {color ? (
              <i className="fa fa-minus" aria-hidden="true" />
            ) : (
              <i className="fa fa-plus" aria-hidden="true" />
            )}{" "}
            &nbsp;
            {dictionary
              ? dictionary["WO_CONFIGURE_EMAIL_SER_1376091544"]
              : "Configure E-Mail Server"}
          </li>

          <Collapse in={color}>
            <div id="example-collapse-text" className="px-3">
              <h6 className="fw-bold">
                {dictionary
                  ? dictionary["WO_MTA_PLATFORM_INCLUDE_-587603668"]
                  : `MTA Platform includes an e-mail delivery extension so that you can send e-mail notifications from MTA. Depending on how you define the e-mail notification, a delivery might consist of a notification, link and attachment. The e-mail delivery extension works with your existing mail server technology. The mail server must be an Outgoing mail server (SMTP) . Ensure your Outgoing mail server (SMTP) supports connection via Java API. Contact your IT team for the parameters below.`}
              </h6>

              <div className="form form-row">
                <div className="col-lg-6 col-md-6 mb-3 mt-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_SERVICE_PROVIDE_1613868671"]
                      : "Service Provider"}
                  </label>
                  <Select
                    options={[
                      { label: "SMTP", value: "SMTP" },
                      { label: "MANDRILL", value: "MANDRILL" },
                    ]}
                    isClearable={false}
                    isSearchable={true}
                    maxMenuHeight={250}
                    menuPlacement="bottom"
                    menuPortalTarget={menuPortalTarget}
                    value={serviceProvider}
                    onChange={(option) => setServiceProvider(option)}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-3 mt-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_USER_NAME_EG_EXA_-1665099566"]
                      : "User name: (e.g. example@gmail.com)"}
                  </label>
                  <input
                    className="form-control"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-3 mt-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_EMAIL_SERVER_PASSW_-385595514"]
                      : "E-mail Server Password"}
                  </label>
                  <input
                    type={"password"}
                    className="form-control"
                    value={emailServer}
                    onChange={(e) => setEmailServer(e.target.value)}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-3 mt-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_OUTGOING_MAIL_SERVER_262518591"]
                      : "Outgoing mail server (SMTP) name"}
                  </label>
                  <input
                    type={"text"}
                    className="form-control"
                    value={outgoingEmail}
                    onChange={(e) => setOutgoingEmail(e.target.value)}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-3 mt-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_PORT_NUMBE_-1885708016"]
                      : "Outgoing mail server (SMTP) Port Number"}
                  </label>
                  <input
                    type={"number"}
                    className="form-control"
                    value={outgoingPort}
                    onChange={(e) => setOutgoingPort(e.target.value)}
                  />
                </div>

                <div className="col-lg-6 col-md-6 mb-3 mt-3">
                  <label>
                    {dictionary
                      ? dictionary["WO_TEST_EMAIL_ADDRES_-1408682654"]
                      : "Test Email Address: (e.g. example@gmail.com)"}
                  </label>
                  <input
                    type={"email"}
                    className="form-control"
                    value={testEmail}
                    onChange={(e) => setTestEmail(e.target.value)}
                  />
                </div>

                <div className="col-lg-6 col-md-6 float-end mb-3 mt-2">
                  <button
                    onClick={() => setUpTestEmailServer(testPayload)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                    disabled={disabled}
                  >
                    {isLoading ? (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    ) : (
                      `${
                        dictionary
                          ? dictionary["WO_EMAIL_SETTING_VALIDA_-1310060834"]
                          : "TEST"
                      }`
                    )}
                  </button>
                </div>

                <div className="col-lg-6 col-md-6 float-end mb-3 mt-2">
                  <button
                    onClick={() => setUpEmailServer(payload)}
                    className="login100-form-btn btn-primary fw-bold text-uppercase"
                    type={"button"}
                    disabled={disabled}
                  >
                    {loading ? (
                      <>
                        <i className="fa fa-spinner fa-spin" />
                      </>
                    ) : (
                      `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Collapse>
        </ul>
      </Card>
    </>
  );
}

export default ConfigureEmailServer;
